import * as React from 'react';

/**
 * Пользовательский хук, который преобразует callback в ref, чтобы избежать повторных рендеров при передаче в качестве
 * пропса или избежать повторного выполнения эффектов при передаче в качестве зависимости
 */
function useCallbackRef(callback) {
  const callbackRef = React.useRef(callback);
  React.useEffect(() => {
    callbackRef.current = callback;
  });

  // https://github.com/facebook/react/issues/19240
  return React.useMemo(() => function () {
    var _callbackRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
  }, []);
}
export { useCallbackRef };